import notification from 'app/config/notification';
import { useRef } from 'react';

export default function useShowFormErrors() {
  const formElement = useRef(null);

  function scrollToErrors() {
    if (formElement.current) {
      formElement.current.scrollIntoView({ behavior: 'smooth' });
    } else {
      document.getElementById('root').scrollIntoView({ behavior: 'smooth' });
    }
    notification('O(s) campo(s) sinalizado(s) precisam de revisão.', {
      toastId: 'FORM_VALIDATION',
      type: 'error',
    });
  }

  return { scrollToErrors, formElement };
}
